



















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { PurchasedItem } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import useCoverThumbnail from "@/hooks/useCoverThumbnail";
import { getFilesIcon } from "@/lib/fileHelpers";
import { MAIN_CONTAINER_WIDTH } from "@/const";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseImage from "@/components/BaseImage";
import ContentCover from "@/components/ContentCover";
import usePurchasedItem from "@/views/PagePurchaseGallery/hooks/usePurchasedCover";

export default defineComponent({
  name: "PurchasedCover",
  components: { BaseIcon, BaseImage, ContentCover },
  props: {
    purchasedItem: { type: Object as PropType<PurchasedItem>, required: true },
  },
  setup(props) {
    const { isRichText, coverFile } = usePurchasedItem(props.purchasedItem);

    const { coverSrc: coverFileSrc } = useCoverThumbnail(coverFile, MAIN_CONTAINER_WIDTH / 2);

    const coverSrc = computed(() =>
      !!coverFileSrc.value
        ? coverFileSrc.value
        : isRichText.value
        ? "/img/content-preview-rich_text.svg"
        : "/img/content-preview-media.svg"
    );

    const showDarkGradient = computed(() => isRichText.value && !!coverFile.value);

    const icon = computed(() => {
      if (isRichText.value) {
        return "sci-text-post";
      } else {
        return getFilesIcon(props.purchasedItem.files);
      }
    });

    return { coverSrc, showDarkGradient, icon };
  },
});
